/**
 * /reports/agent — Reports agent (Pack 16 v2).
 */
import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

const REPORTS_BY_AGENT = [
  {
    agent: "tashghil" as const,
    reports: ["Headcount", "Turnover", "Onboarding pipeline", "Approval queue aging"],
  },
  {
    agent: "rawatib" as const,
    reports: ["Compensation analysis", "Payroll reconciliation", "Cost-by-LE", "GOSI quarterly"],
  },
  {
    agent: "mutabaa" as const,
    reports: ["Compliance dashboard", "Nitaqat tier", "ZATCA annual", "Year-end audit pack"],
  },
  {
    agent: "khidmat" as const,
    reports: ["Natural-language report queries", "Conversational drilldowns", "Saved shortcuts"],
  },
];

export function ReportsAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Reports Agent"
        subtitle="All four agents publish reports. Khidmat handles natural-language queries."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {REPORTS_BY_AGENT.map((g) => (
          <section
            key={g.agent}
            className="bg-surface-default border border-border-default rounded-lg p-4"
          >
            <div className="flex items-center gap-2 mb-3">
              <AgentBadge agent={g.agent} />
              <h3 className="text-base font-semibold">Reports</h3>
            </div>
            <ul className="text-sm text-text-secondary space-y-1.5">
              {g.reports.map((r) => (
                <li key={r}>{r}</li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </div>
  );
}
